import { render } from "./ToggleSwitch.vue?vue&type=template&id=43b15330&scoped=true&ts=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./ToggleSwitch.vue?vue&type=script&lang=ts"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=43b15330&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b15330"]])

export default __exports__